const productCardSwiper = new Swiper('.product-card__card-swiper', {
    slidesPerView: 1,
    spaceBetween: 0,
    allowTouchMove: false,
    pagination: {
        el: '.product-card__swiper-pagination',
        clickable: true,

        renderBullet: function (index, className) {
            return '<div class="' + className + ' swiper-custom-product-card"></div>'
        },
    },
})

export default productCardSwiper
